import * as yup from 'yup';

// Pattern zur Validierung von E-Mail-Adressen gemäß RFC 5322
// siehe https://www.abstractapi.com/guides/email-address-pattern-validation
const EMAIL_ADDRESS_PATTERN = /^([-!#-'*+/-9=?A-Z^-~]+(\.[-!#-'*+/-9=?A-Z^-~]+)*|"([]!#-[^-~ \t]|(\\[\t -~]))+")@([-!#-'*+/-9=?A-Z^-~]+(\.[-!#-'*+/-9=?A-Z^-~]+)*|\[[\t -Z^-~]*])$/;

// YUP-Schema zur Validierung von E-Mail-Adressen
export const emailValidation = (message: string|undefined) => yup.string().matches(EMAIL_ADDRESS_PATTERN, message);
